import { IErrorHandling, OnboardingFormFields } from '@Types/index';

export const BusinessErrorMap = {
  BUSINESS_NAME_ILLEGAL_NAME: 80003,
  LLC_INVALID_EIN: 80004,
  LLC_INVALID_STATE: 80005,
  EIN_IS_NOT_SSN: 80010,
  EIN_ALREADY_EXISTS: 80012,
  EIN_NOT_UNIQUE: 80013,
  OWNERSHIP_PERCENT_NOT_VALID: 90223,
};

export const BusinessErrorsObjectMap = new Map<number, IErrorHandling>([
  [
    BusinessErrorMap.BUSINESS_NAME_ILLEGAL_NAME,
    {
      errorCode: BusinessErrorMap.BUSINESS_NAME_ILLEGAL_NAME,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.BUSINESS_NAME,
      callBack: () => {},
    },
  ],
  [
    BusinessErrorMap.LLC_INVALID_EIN,
    {
      errorCode: BusinessErrorMap.LLC_INVALID_EIN,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
      callBack: () => {},
    },
  ],
  [
    BusinessErrorMap.LLC_INVALID_STATE,
    {
      errorCode: BusinessErrorMap.LLC_INVALID_STATE,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.BUSINESS_REGISTER_STATE,
      callBack: () => {},
    },
  ],
  [
    BusinessErrorMap.EIN_IS_NOT_SSN,
    {
      errorCode: BusinessErrorMap.EIN_IS_NOT_SSN,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
      callBack: () => {},
    },
  ],
  [
    BusinessErrorMap.EIN_ALREADY_EXISTS,
    {
      errorCode: BusinessErrorMap.EIN_ALREADY_EXISTS,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
      callBack: () => {},
    },
  ],
  [
    BusinessErrorMap.EIN_NOT_UNIQUE,
    {
      errorCode: BusinessErrorMap.EIN_NOT_UNIQUE,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.BUSINESS_EIN,
      callBack: () => {},
    },
  ],
  [
    BusinessErrorMap.OWNERSHIP_PERCENT_NOT_VALID,
    {
      errorCode: BusinessErrorMap.OWNERSHIP_PERCENT_NOT_VALID,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.OWNER_PERCENTAGE,
      callBack: () => {},
    },
  ],
]);
